import './form.js';
import './gf.js';
import './termly-banner-customizer.js';
import {Nav} from "./nav";
import {History} from "./cf-history";
import {Video} from "./video";
import {Popup} from "./popup";


//Initiate fullpage.js
window.myFullpage = new fullpage('#fullpage', {
    menu: '#menu',
    anchors: ['hello', 'about', 'culture', 'octane', 'products', 'operations', 'onboarding-training', 'marketing', 'benefits', 'contact'],
    scrollOverflow: true,
    //scrollOverflowReset: true,
    controlArrows: false,
    verticalCentered: false,
    licenseKey: 'B290F3A4-02574B7E-B6BDC66A-C02E3599',
    scrollOverflowResetKey: 'am9pbmNmLmNvbV9TZkdjMk55YjJ4c1QzWmxjbVpzYjNkU1pYTmxkQT09S0M5',
});


//Carousels
const testimonials2 = new Splide( '#testimonials-onboarding', {
    type   : 'loop',
    // drag:  false
}).mount();

const otherProducts = new Splide( '#other-products', {
    type   : 'loop',
    // drag : false
}).mount();

if (document.getElementById('octane-slider')) {
    const octaneSlider = new Splide( '#octane-slider', {
        type   : 'loop',
        pagination: false,
    }).mount();
}


//Mobile Nav
const nav = new Nav('open-nav', 'close-nav');
nav.init();


//Change CF history items depends on the window size.
const history = new History();
history.init();


//Form submit
// const contactForm = new Form( document.getElementById('join-us-form'), ['first-name', 'last-name', 'email', 'phone', 'state']);
// contactForm.init();

const video = new Video();
video.init();

const popup = new Popup();
popup.init();


